/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Common_OnlineInputs */

const en_pc_common_online = /** @type {(inputs: Pc_Common_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use PdfCraft online`)
};

const zh_pc_common_online = /** @type {(inputs: Pc_Common_OnlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线使用 PdfCraft`)
};

/**
* | output |
* | --- |
* | "Use PdfCraft online" |
*
* @param {Pc_Common_OnlineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_common_online = /** @type {((inputs?: Pc_Common_OnlineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Common_OnlineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_common_online(inputs)
	return zh_pc_common_online(inputs)
});
export { pc_common_online as "pc.common.online" }